<script>
import Layout from '@layouts/main.vue'
import router from '../index'
import { store } from '../../state/store'
import Header from '@components/header.vue'
import FooterComponent from '@components/footer.vue'
import JobService from '@services/business/job.service'
import modal from '@components/modal.vue'
import ErrorAlert from '@components/error-alert.vue'

export default {
  page: {
    title: 'Enroute',
    meta: [{ name: 'description', content: 'The Enroute page.' }],
  },
  components: { Layout, Header, FooterComponent, modal, ErrorAlert },
  data() {
    return {
      isEnRoute: false,
      isAssigned: false,
      job: store.state.currentJob,
      site: store.state.site,
      isInstallJob: store.state.isInstallJob,
      showOnsiteModal: false,
      isLoading: false,
    }
  },
  computed: {
    streetAddress: function() {
      return this.site.siteAddress1 + ' ' + this.site.siteAddress2
    },
    otherAddress: function() {
      return (
        this.site.cityName + ' ' + this.site.stateAbbr + ' ' + this.site.zipCode
      )
    },
    enRouteLoading: function() {
      return this.isLoading && !this.isEnRoute
    },
    onSiteLoading: function() {
      return this.isLoading && this.isEnRoute
    },
    displayStatus: function() {
      switch (this.job.jobEmployeeStatus) {
        case 'A':
          return 'Assigned'
        case 'E':
          return 'En Route'
        case 'O':
          return 'On Site'
        default:
          return 'N/A'
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.isLoading = false
      const jobEmployeeStatus = store.state.currentJob.jobEmployeeStatus
      this.isEnRoute = jobEmployeeStatus === 'E' || jobEmployeeStatus === 'O'
      this.isAssigned = jobEmployeeStatus === 'A'
    },

    setEnRoute() {
      this.isLoading = true
      return (
        JobService.setTechStatusToEnroute(this.job.jobNumber)
          .then(this.init)
          // eslint-disable-next-line handle-callback-err
          .catch((err) => {
            this.isLoading = false
            store.presentErrorAlert('Unable to set tech as En Route.')
          })
      )
    },
    confirmOnSite() {
      if (this.job.jobEmployeeStatus === 'O') {
        if (this.isInstallJob) {
          router.push('signal-test')
        } else {
          router.push('system-test')
        }
      } else {
        this.showOnsiteModal = true
      }
    },
    navigateAddressOnMap() {
      window.open(this.site.googleMapsLink, '_blank')
      this.closeMapModal()
    },
    closeModal() {
      this.showOnsiteModal = false
    },
    setOnSite() {
      this.isLoading = true
      return (
        JobService.setTechStatusToOnSite(this.job.jobNumber)
          .then(() => {
            this.isLoading = false
            router.push('system-test')
          })
          // eslint-disable-next-line handle-callback-err
          .catch((err) => {
            this.isLoading = false
            store.presentErrorAlert('Unable to set tech status to On Site.')
          })
      )
    },
  },
}
</script>

<template>
  <Layout>
    <Header />
    <div class="parent_container">
      <div v-show="enRouteLoading" class="spinner_container">
        <div class="spinner"></div>
      </div>
      <div v-show="!enRouteLoading" class="container">
        <div class="text-center align-middle mt-2">
          <template>
            <h1 class="status-header">TECH STATUS</h1>
            <ErrorAlert></ErrorAlert>
            <p class="text-tech-status"> Your Status is {{ displayStatus }} </p>
            <button
              v-if="isAssigned"
              id="btn-enroute"
              type="button"
              class="btn btn-primary"
              @click="setEnRoute"
              >EN ROUTE</button
            >
            <button
              v-if="isEnRoute"
              type="button"
              class="btn btn-primary"
              @click="confirmOnSite"
              >ON SITE</button
            >
            <div class="customer_address_container">
              <a
                id="link-enroute-site-address"
                class="customer-address"
                target="_blank"
                :href="site.googleMapsLink"
              >
                {{ streetAddress }}<br />
                {{ otherAddress }}
              </a>
            </div>

            <modal v-if="showOnsiteModal" @close="closeModal">
              <div slot="header">
                <h3 class="enroute-modal-header">CONFIRM ON SITE</h3>
              </div>
              <div slot="body">
                <div v-show="onSiteLoading" class="modal_spinner_container">
                  <div class="spinner"></div>
                </div>
                <div v-show="!onSiteLoading">
                  <ErrorAlert></ErrorAlert>
                  <p
                    >Are you sure that you want to change your status to On
                    Site?</p
                  >
                </div>
              </div>
              <FooterComponent
                slot="footer"
                secondary-btn-type="link"
                secondary-btn-text="CANCEL"
                :secondary-btn-callback="closeModal"
                primary-btn-text="CONFIRM"
                :primary-btn-callback="setOnSite"
                :primary-btn-disable-state="onSiteLoading"
                primary-btn-id="btn-onsite"
                class="footer-container-override"
              ></FooterComponent>
            </modal>
          </template>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.customer_address_container {
  margin-top: 1em;
  margin-bottom: 2em;
}

.parent_container {
  position: relative;
  top: $height-status-bar;
  max-width: $size-parent-container-width-max;
  margin: auto;
  text-align: center;
}

.spinner_container {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: $size-parent-container-width-max;
  height: 100%;
}

.modal_spinner_container {
  margin: 4em;
}

.enroute-btn-secondary:hover {
  background-color: $color-text-secondary;
}

.enroute-modal-header {
  margin-bottom: 0;
  font-weight: 900;
  color: $color-text-primary;
}

.footer-container-override {
  position: relative;
  height: auto;
  padding-top: 0.5em;
  background-color: $color-body-bg;
}

.status-header {
  font-weight: 900;
  color: $color-text-primary;
}

.customer-address {
  font-family: $system-default-font-family;
  font-size: 1em;
  font-weight: $heading-font-weight;
  color: $color-text-primary;
  text-decoration: underline;
  cursor: pointer;
}

.customer-address:hover {
  text-decoration: underline;
}

.text-tech-status {
  margin-bottom: 1em;
  font-size: 1.35em;
  font-weight: $heading-font-weight;
  color: $color-text-success;
}

a {
  color: $color-text-primary;
}

a:visited {
  color: $color-text;
}
</style>
